<template>
  <div class="play-canvas">
    <v-dialog v-model="dialog" max-width="950">
      <v-card>
        <v-card-text>
          <div class="d-flex justify-space-between pt-2">
            <h3 class="black--text">Edit Window Configurator</h3>
            <v-icon @click="$emit('close')">mdi-close</v-icon>
          </div>
          <v-divider class="black--text"></v-divider>
          <iframe :src="url" width="100%" height="500" frameborder="0"></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    }
  },
  created() {
    if (this.item && this.item.config_id) {
      // this.url = `https://playcanv.as/e/p/6e3e0cce/?projectID=20dd4128-0f5f-4c2e-8661-cbbc4bcf5eff&configID=${this.item.config_id}`;
      this.url = `https://res-win-config.netlify.app/`;
    }
  },
  data() {
    return {
      url: 'https://res-win-config.netlify.app/'
    };
  }
};
</script>
